import React from "react";
import "./style.css";
export default function Textarea(props) {
    const { content, result } = props;
    return (React.createElement("div", { className: "satisfaction-chooser-container" },
        content.label,
        React.createElement("textarea", { placeholder: content.areaPlaceholder, value: result === null || result === void 0 ? void 0 : result.message, onChange: (event) => {
                const value = event.target.value;
                props.onUpdate({ type: "textarea", message: value });
            } })));
}
